import { create } from 'zustand';
import type { SSEEvent } from '@/types/api';

const MAX_EVENTS = 100;

interface FeedState {
  events: SSEEvent[];
  connected: boolean;
  error: string | null;
  newEventCount: number;
  addEvent: (event: SSEEvent) => void;
  setConnected: (connected: boolean) => void;
  setError: (error: string | null) => void;
  markAllRead: () => void;
}

export const useFeedStore = create<FeedState>((set) => ({
  events: [],
  connected: false,
  error: null,
  newEventCount: 0,

  addEvent: (event: SSEEvent) =>
    set((state: FeedState) => ({
      events: [event, ...state.events].slice(0, MAX_EVENTS),
      newEventCount: state.newEventCount + 1,
    })),

  setConnected: (connected: boolean) => set({ connected }),

  setError: (error: string | null) => set({ error }),

  markAllRead: () => set({ newEventCount: 0 }),
}));
